import type { MiddlewareAPI } from 'redux';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/mergeMap';
import { getReportList } from '../../services/reports-list';
import { LOAD_DATA, setData } from '../../state/actions/app';
import type { State, ActionsObservable } from '../../state/types';

export const epic = (action$: ActionsObservable, store: MiddlewareAPI<State>) =>
	action$
		.ofType(LOAD_DATA)
		.mergeMap(() =>
			getReportList(store).mergeMap((reportsList) => Observable.of(setData(reportsList))),
		);
